<div id="graphicsCopntainer" class=container1>
    <div id="graphicsFactTage" class="main-content graphicsPadding">
        <div id="ftags" class="fact_tags mt-3 clr-white">{{graphics}}</div>
    </div>
</div>